var _rect, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolanaRoundSquareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 21.3333,
    fill: "#1A1A1A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6004 40.4281C17.8615 40.1785 18.2155 40.0383 18.5845 40.0383H52.6357C53.256 40.0383 53.5665 40.7562 53.1277 41.1758L46.3993 47.6101C46.1382 47.8598 45.7843 48 45.4152 48H11.364C10.7437 48 10.4332 47.2821 10.8719 46.8625L17.6004 40.4281Z",
    fill: "url(#paint0_linear_258_4043)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6004 16.3899C17.8615 16.1402 18.2154 16 18.5845 16H52.6357C53.256 16 53.5665 16.7179 53.1277 17.1375L46.3993 23.5719C46.1382 23.8215 45.7842 23.9617 45.4152 23.9617H11.364C10.7437 23.9617 10.4332 23.2438 10.8719 22.8242L17.6004 16.3899Z",
    fill: "url(#paint1_linear_258_4043)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3993 28.3325C46.1382 28.0828 45.7842 27.9426 45.4152 27.9426H11.364C10.7437 27.9426 10.4332 28.6605 10.8719 29.0801L17.6004 35.5144C17.8615 35.7641 18.2154 35.9043 18.5845 35.9043H52.6357C53.256 35.9043 53.5665 35.1864 53.1277 34.7668L46.3993 28.3325Z",
    fill: "url(#paint2_linear_258_4043)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_258_4043",
    x1: 39.5117,
    y1: 7.22228,
    x2: 17.5305,
    y2: 51.2145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_258_4043",
    x1: 39.5117,
    y1: 7.22228,
    x2: 17.5305,
    y2: 51.2145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_258_4043",
    x1: 39.5117,
    y1: 7.22228,
    x2: 17.5305,
    y2: 51.2145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolanaRoundSquareIcon);
export default __webpack_public_path__ + "static/media/Solana Round Square Icon.483f7281151d3b0a1fea735b34faff66.svg";
export { ForwardRef as ReactComponent };